/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 4/9/2019.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Grid, Card, Button} from "@scuf/common";
import Loader from "../common/Loader";
import DashboardHeader from "./DashboardHeader";
import {LOG_ACTION_TYPES} from "../faults/common/FaultsConst"
import {fetchActionLog as fleetsFetchActionLog} from '../api/Fleets'
import {checkCorruptionOfDatabases, fetchLdisInfo, fetchAppConfigs, testConnectionAll} from '../api/AppConfigs'
import ActionLogTable from "../faults/common/ActionLogTable";
import {
    fetchDayStats as llFetchDayStats,
    checkUpdate as llCheckUpdate,
    update as llUpdate,
    LearningLoopUpdateAvailabilityResult,
    LearningLoopUpdateResult,
    LearningLoopUpdateAvailabilityResultErrorReason
} from "../api/LearningLoop";
import {formatDateTime, formatMessage} from "../common/LocaleHelper";
import {showNotification} from "../common/ToastNotification";
import LearningLoopCountChart from './LearningLoopCountChart'
import StatusIcon from "../common/StatusIcon";
import {Link} from "react-router-dom";
import CorruptionModal from "../common/CorruptionModal";
import {autoCloseInactiveFaults} from "../api/Faults";
import {anonymizeUserData} from "../api/Users";

class AdminDashboard extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            actionLog: null,
            ldisInfo: [],
            dayStats: [],
            kmsConnection: null,
            kmsURL: '',
            databaseCorruptionResult: null,
            closeCorruptionModal: false,
        }

        this.performDeltaLlUpdate = this.performDeltaLlUpdate.bind(this)
    }

    componentDidMount() {
        this.setState({loading: true})
        this.checkCorruptionOfDatabase()
        Promise.all([
            this.fetchActionLogs(),
            this.fetchLdisInfo(),
            this.fetchDayStats(),
        ]).then(() => {
            this.setState({loading: false})
        })
        this.autoCloseInactiveFaults()
        this.anonymizeUserData()
    }

    checkCorruptionOfDatabase() {
        checkCorruptionOfDatabases().then((data) => {
            if (data != null && data.user != null && data.logString != null) {
                this.setState({databaseCorruptionResult: data, closeCorruptionModal: true})
            }
        })
    }

    fetchActionLogs() {
        fleetsFetchActionLog([LOG_ACTION_TYPES.VALUE_SET, LOG_ACTION_TYPES.REPORTED,
            LOG_ACTION_TYPES.STATE_CHANGED, LOG_ACTION_TYPES.LL_PACKET_SENT, LOG_ACTION_TYPES.ASSIGNEE_SET, LOG_ACTION_TYPES.LDI_IMPORT], []).then((data) => {
            this.setState({actionLog: data})
        })
    }

    fetchDayStats() {
        llFetchDayStats(15).then((data) => {
            this.setState({dayStats: data})
        })
    }

    fetchLdisInfo() {
        fetchLdisInfo().then(data => {
            data.forEach((ldi) => {
                fetchAppConfigs(ldi.ldiId).then((appConfig) => {
                    const url = appConfig.find(c => c.name === 'KMS_LL_URL');
                    if (url) {
                        ldi.kmsURL = url.value
                    }
                }).catch(() => {
                    ldi.kmsURL = ''
                })
                if (ldi.kmsURL == null) {
                    ldi.kmsURL = ''
                }
                this.updateLdiInfoInState(ldi)
                ldi.llUpdate = {loading: true}
                llCheckUpdate(ldi.ldiId).then(update => {
                    ldi.llUpdate = {
                        loading: false,
                        ...update,
                    }

                    ldi.llUpdate.updateAvailabilityResult = ldi.llUpdate.updateResult
                    delete ldi.llUpdate.updateResult

                    this.updateLdiInfoInState(ldi)
                })
            })
            this.setState({ldisInfo: data}, () => {
                testConnectionAll().then((connectionData) => {
                    connectionData.forEach(d => {
                        const ldi = this.state.ldisInfo.filter(l => l.ldiId === d.key)
                        ldi[0].kmsConnection = d.value
                        this.updateLdiInfoInState(ldi)
                    })
                })
            })
        })
    }

    autoCloseInactiveFaults() {
        const {intl} = this.props

        autoCloseInactiveFaults().then(
            (response) => {
                if (response) {
                    showNotification({
                        translationPropertyKey: 'fault.action.autoclose.success',
                        severity: "success",
                    });
                }
            }
        )
    }

    anonymizeUserData() {
        const {intl} = this.props
        anonymizeUserData().then((response) => {
            if (response) {
                showNotification({
                    translationPropertyKey: "anonymization.call.successful",
                    severity: "success",
                })
            }
        }).catch((error) => {
            showNotification({
                translationPropertyKey: intl.formatMessage({id: "anonymization.call.failed"}) + error.status + " " + error.statusText,
                severity: "critical",
            });
        })
    }

    getVersionsCard() {
        const {intl} = this.props

        return <Card>
            <Card.Header title={intl.formatMessage({id: 'dashboard.versions.availableUpdates'})}>
                <div className="right">
                    <Button type="primary" size="small" onClick={() => this.fetchLdisInfo()}><FormattedMessage id="dashboard.versions.update.refresh"/></Button>
                </div>
            </Card.Header>
            <Card.Content>
                {this.state.ldisInfo.map(ldi => this.getLdiInfoGridComponent(ldi))}
            </Card.Content>
        </Card>
    }

    getLdiInfoGridComponent(ldiInfo) {
        let dlluUpdateComponent
        let statusColor
        if (ldiInfo.llUpdate.loading) {
            dlluUpdateComponent = <Loader loading={true} text=" " overlayOpacity={0} className="small"/>
        } else if (ldiInfo.llUpdate.updateResult) {
            statusColor = "green"
            dlluUpdateComponent = <FormattedMessage id="dashboard.versions.update.success"/>
        } else if (ldiInfo.llUpdate.updateAvailabilityResult) {
            switch (ldiInfo.llUpdate.updateAvailabilityResult) {
                case LearningLoopUpdateAvailabilityResult.LDI_UPDATE_NO_UPDATE_NEEDED:
                    statusColor = "green"
                    dlluUpdateComponent = <FormattedMessage id="dashboard.versions.noupdate"/>
                    break;
                case LearningLoopUpdateAvailabilityResult.LDI_UPDATE_AVAILABLE:
                    statusColor = "blue"
                    dlluUpdateComponent = <span>
                        <FormattedMessage id="dashboard.versions.ldi.dlluUpdateAvailable"
                                          values={{date: formatDateTime(ldiInfo.llUpdate.newPacketVersion)}}/>
                        <Button type="link" onClick={() => this.performDeltaLlUpdate(ldiInfo.ldiId)}><FormattedMessage
                            id="dashboard.versions.updatenow"/></Button>
                    </span>
                    break;
                case LearningLoopUpdateAvailabilityResult.LDI_UPDATE_PROCESSING_ERROR:
                    if (LearningLoopUpdateAvailabilityResultErrorReason.LL_UPDATE_PACKET_VERSION_RECEIVED_WITH_FALSE_STATE === ldiInfo.llUpdate.errorReason) {
                        dlluUpdateComponent = ldiInfo.llUpdate.errorMessage;
                    } else {
                        dlluUpdateComponent =
                            <FormattedMessage id={"dashboard.versions.error." + ldiInfo.llUpdate.errorReason}/>
                    }
                    statusColor = "red"
                    break;
                default:
                    statusColor = "red"
                    dlluUpdateComponent = <FormattedMessage id={"dashboard.versions.error"}/>
                    break;
            }
        } else {
            // default ldi info component values
            statusColor = "red"
            dlluUpdateComponent = <FormattedMessage id={"dashboard.versions.error"}/>
        }

        let oldPacketVersion
        if (ldiInfo.llUpdate.oldPacketVersion) {
            oldPacketVersion = formatDateTime(ldiInfo.llUpdate.oldPacketVersion)
        } else if (!ldiInfo.llUpdate.loading) {
            oldPacketVersion = formatMessage({id: "dashboard.versions.ldi.dlluUpdateDate.never"})
        } else {
            oldPacketVersion = ''
        }

        return <Grid className="ldi-version-table" key={ldiInfo.ldiId}>
            <Grid.Row>
                <Grid.Column width={3} sWidth={12}>
                    <div><StatusIcon color="green"/> {ldiInfo.displayName}</div>
                </Grid.Column>
                <Grid.Column width={3} sWidth={12}><FormattedMessage id="dashboard.versions.ldi.createdDate"
                                                         values={{date: formatDateTime(ldiInfo.creationDate)}}/></Grid.Column>
            </Grid.Row>
            <Grid.Row className="dllu-info">
                <Grid.Column width={3} sWidth={12} className="dllu-name">
                    <div><StatusIcon color={statusColor}/> <FormattedMessage id="dashboard.versions.dllu"/></div>
                </Grid.Column>
                <Grid.Column width={3} sWidth={12}><FormattedMessage id="dashboard.versions.ldi.dlluUpdateDate"
                                                                     values={{date: oldPacketVersion}}/></Grid.Column>
                <Grid.Column width={6} sWidth={12} className="small-loader-wrap">
                    {dlluUpdateComponent}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    }

    performDeltaLlUpdate(ldiId) {
        const ldiInfo = this.state.ldisInfo.filter(ldi => ldi.ldiId === ldiId)[0];
        ldiInfo.llUpdate.loading = true
        this.updateLdiInfoInState(ldiInfo)

        llUpdate(ldiId).then((data) => {
            ldiInfo.llUpdate.loading = false
            if (data.updateResult === LearningLoopUpdateResult.LDI_UPDATE_SUCCESSFUL || data.updateResult === LearningLoopUpdateResult.LDI_UPDATE_NOTHING_TO_UPDATE) {
                ldiInfo.llUpdate.oldPacketVersion = data.newPacketVersion
                ldiInfo.llUpdate.updateResult = data.updateResult
                showNotification({
                    title: formatMessage({id: 'dashboard.versions.update.success.notification'}, {count: data.numberOfUpdatedElements}),
                    severity: "success",
                })
            } else {
                showNotification({
                    translationPropertyKey: "dashboard.versions.update.error",
                    severity: "critical",
                })
            }
            this.updateLdiInfoInState(ldiInfo)
        })
    }

    updateLdiInfoInState(ldiInfo) {
        this.setState({
            ldisInfo: this.state.ldisInfo.map(el => (el.ldiId === ldiInfo.ldiId ? {...el, ldiInfo} : el)),
        });
    }

    getActionLogCard() {
        const {intl} = this.props
        if (this.state.actionLog == null) {
            return null
        }

        return <Card>
            <Card.Header title={intl.formatMessage({id: 'dashboard.versions.latestActionLogs'})}>
            </Card.Header>
            <Card.Content>
                <ActionLogTable actionLog={this.state.actionLog} initDisplayCount={5} displayAssetName={true}
                                displayFaultName={true}/>
            </Card.Content>
        </Card>
    }

    getKmsConnectionStatusCard() {
        const {intl} = this.props

        const rows = this.state.ldisInfo.map(ldi => {
            let kmsConnectionStatusMessage
            let kmsConnectionStatusColor
            if (ldi.kmsConnection == null) {
                kmsConnectionStatusMessage = <Loader loading={true} text=" " overlayOpacity={0} className="small"/>
            } else if (ldi.kmsConnection) {
                kmsConnectionStatusColor = "green"
                kmsConnectionStatusMessage = <FormattedMessage id="dashboard.connection.KMS.connected"/>
            } else {
                kmsConnectionStatusColor = "red"
                kmsConnectionStatusMessage = <FormattedMessage id="dashboard.connection.KMS.disconnected"/>
            }
            return (
                <Grid.Row key={ldi.id}>
                    <Grid.Column withd={4} sWidth={12} >
                        <FormattedMessage id="multipleLdis.name" values={{ldiName: ldi.displayName}}/>
                    </Grid.Column>
                    <Grid.Column width={1} sWidth={4} >
                        <div>
                            <StatusIcon color={kmsConnectionStatusColor}/> <FormattedMessage id="dashboard.connection.KMS"/>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={2} sWidth={8} className="small-loader-wrap">
                        {kmsConnectionStatusMessage}
                    </Grid.Column>
                    <Grid.Column width={4} sWidth={12}>
                        <FormattedMessage id="dashboard.connection.KMS.URL"
                                          values={{URL: ldi.kmsURL}}/>
                    </Grid.Column>
                </Grid.Row>
            )
        })

        return <Card className="kms-card">
            <Card.Header title={intl.formatMessage({id: 'dashboard.connection.KMS.title'})}>
                <div className="right">
                    <Link to={'/administration/appConfig'}><Button type="primary" size="small"><FormattedMessage id="dashboard.connection.KMS.button.config"/></Button></Link>
                </div>
            </Card.Header>
            <Card.Content>
                <Grid>
                    {rows}
                </Grid>
            </Card.Content>
        </Card>
    }

    render() {
        return (
            <div>
                <CorruptionModal
                    open={this.state.closeCorruptionModal}
                    onClose={() => {this.setState({closeCorruptionModal: false})}}
                    databaseCorruptionResult={this.state.databaseCorruptionResult}
                />
                <Loader loading={this.state.loading}/>
                <DashboardHeader bottomChildren={
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <LearningLoopCountChart dayCounts={this.state.dayStats} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>}>
                </DashboardHeader>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            {this.getKmsConnectionStatusCard()}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            {this.getVersionsCard()}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            {this.getActionLogCard()}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

export default injectIntl(withRouter(connect(mapStateToProps)(AdminDashboard)))